import PrimaryButton from "@/components/common/PrimaryButton";
import Image from "next/image";

const BigImageSection = (properties) => (
  <div className="md:py-16 px-4 md:px-8 lg:px-10 bg-primary-black">
    <div className='fs-0'>
    <Image
      alt={properties.alt}
      height={800}
      objectFit="cover"
      src={properties.src}
      title={properties.title}
      width={1900}
    />
    </div>
    <div className="pt-8 pb-16 md:pt-16 md:pr-2 xl:pl-[24rem] xl:pb-0">
      <p className="w-full md:w-5/6 text-base font-medium text-white text-justify [&_a]:text-[#00b1f0] mb-4">
        <span dangerouslySetInnerHTML={{ __html: properties.details }}></span>
      </p>
      <div className="pt-12">
        <PrimaryButton
          arrow={false}
          link={properties.link}
          val={properties.val}
        />
      </div>
    </div>
  </div>
);

export default BigImageSection;
